import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

export class BrandDataService {
  async getBrandSearch(params: any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/search?value=${params}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Search :: ${error}`);
    }
  }

   async getBrandData(params: any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/details?ref_id=${params}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }


  // .......................................Without time range required.........................................................

  async profileCard(params: any, shareAccessKey?: any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/profileCard?ref_id=${params}&share_access_key=${shareAccessKey}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }


  
  async getSimailarBrandInfluencers(selectedRefId:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/getSimailarBrandInfluencers?ref_id=${selectedRefId}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }

    async topData(params: any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/topData?ref_id=${params}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }


  // .......................................Time range required.........................................................

    async getEngagedInfluencer(selectedRefId:any,media_type:any,type:any,paid_type:any,day_range:any ): Promise<any> {
    try {
      const path = BASE_URL + `/brand/getEngagedInfluencer?ref_id=${selectedRefId}&media_type=${media_type}&type=${type}&paid_type=${paid_type}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }

  async amountEMVGraph(selectedRefId:any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/amountEmvGraph?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
 async influencerEngagementSummary(selectedRefId:any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/influencerEngagemntSummary?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
  
  async growthChart(selectedRefId:any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/growthChart?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
  async influencerEngagementGraph(selectedRefId:any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/influencerEngagemntGraph?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
  async addBrand(value:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/addBrand?value=${value}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
  async snapshotSummary(selectedRefId:any,paid_type:any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/snapshotSummary?ref_id=${selectedRefId}&paid_type=${paid_type}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
      async compareBrandData(params: any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/compare?ref_id=${params}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }


  async metricCard(selectedRefId: any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/metricCard?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
 
    async hashtags(selectedRefId: any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/hashtags?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }

    async getComments(selectedRefId: any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/getComments?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
  async getCompareBrandAddOn(selectedRefId: any,day_range:any): Promise<any> {
    try {
      const path = BASE_URL + `/brand/compareAddOn?ref_id=${selectedRefId}&day_range=${day_range}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
  /**
   * Brand Pulse :: is this handle already tracked?
   * Used by the "Add Brand" Verify step so a duplicate is caught before the user fills
   * in the name and industry. The add endpoint re-checks server side regardless.
   */
  async checkBrandPulseUsername(username: string): Promise<any> {
    try {
      const path = BASE_URL + `/brand/pulse/check-username?username=${encodeURIComponent(username)}`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Check Brand Pulse Username :: ${error}`);
    }
  }

  // Brand Pulse :: industry dropdown for the "Add Brand" form (datalake master_industry)
  async getBrandPulseIndustries(): Promise<any> {
    try {
      const path = BASE_URL + `/brand/pulse/industries`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Pulse Industries :: ${error}`);
    }
  }

  /**
   * Brand Pulse :: add a brand handle so the profile-fetch service starts tracking it.
   * Backend inserts into sheet_brand_handles_data with priority = 1, bright_data_priority = 1
   * and service_running = 'true'.
   */
  async addBrandPulseBrand(payload: { user_id: any; name: string; username: string; industry_id: any }): Promise<any> {
    try {
      const path = BASE_URL + `/brand/pulse/add`;
      const response = await http.postRequest(path, payload, null);
      return response;
    } catch (error) {
      throw new Error(`Add Brand Pulse Brand :: ${error}`);
    }
  }

  async getBrandCategorySearchBar(): Promise<any> {
    try {
      const path = BASE_URL + `/brand/brandCategorySearchBar`;
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Data :: ${error}`);
    }
  }
}

